/* @flow */

export function goBack(history: any, defaultRoute?: string) {
  // Prevent going back to origin
  if (
    defaultRoute &&
    ((window && window.location.search.match(/[?|&]origin=/)) ||
      (history && history.length < 2))
  ) {
    history.push(defaultRoute);
  } else if (history && history.goBack) {
    history.goBack();
  }
}
